module.exports = __webpack_public_path__ + "static/media/ui-ux.3d638263.svg";